<script>
  import moment from 'moment';
  import DatePicker from 'vue2-datepicker';
  import conciliacaoProjetoServico from '../servico';

  const LIMITE_BUSCA = 200;

  function arredondar(v) {
    return Math.round((+v || 0) * 100) / 100;
  }

  function lerNumero(texto) {
    const limpo = (texto || '').toString().trim().replace(/\./g, '').replace(',', '.');
    if (!limpo) return 0;
    const numero = +limpo;
    return isNaN(numero) ? 0 : numero;
  }

  export default {
    components: { DatePicker },
    props: {
      value: { type: Object, default: null },
      total: { type: Number, default: 0 },
      sugestoes: { type: Array, default: () => [] },
      invalido: { type: Boolean, default: false },
      idContaCript: { type: String, default: '' },
    },
    data() {
      return {
        aberto: false,
        carregando: false,
        erro: '',
        lista: null,
        escolhida: null,
        detalhe: null,
        carregandoDetalhe: false,
        erroDetalhe: '',
        filtro: { busca: '', dataIni: null, dataFim: null },
        temporizador: null,
        pedido: 0,
        pedidoDetalhe: 0,
      }
    },
    computed: {
      sugestoesBusca() {
        const lista = [];
        (this.sugestoes || []).forEach(s => {
          const t = (s || '').toString().trim();
          if (t && lista.indexOf(t) < 0) lista.push(t);
        });
        return lista;
      },
      noLimite() { return (this.lista || []).length >= LIMITE_BUSCA; },
      podeBuscar() {
        const busca = this.filtro.busca.trim();
        return /^\s*(s\s*p\s*[.\-]?\s*)?\d+\s*$/i.test(busca) || busca.length >= 3
          || !!this.filtro.dataIni || !!this.filtro.dataFim;
      },
      linhas() { return (this.value && this.value.linhas) || []; },
      distribuido() { return arredondar(this.linhas.reduce((s, l) => s + (+l.valor || 0), 0)); },
      falta() { return arredondar(this.total - this.distribuido); },
      linhasAcimaDoSaldo() { return this.linhas.filter(l => (+l.valor || 0) > (+l.saldo || 0) + 0.005); },
      temItem() { return this.linhas.some(l => l.idProjetoItemControle > 0); },
    },
    watch: {
      total(novo, antigo) {
        if (!this.value || arredondar(novo) === arredondar(antigo)) return;
        const comSaldo = this.linhas.filter(l => (+l.saldo || 0) > 0);
        this.linhas.forEach(l => {
          l.valor = comSaldo.length === 1 && comSaldo[0] === l ? arredondar(Math.min(novo, +l.saldo || 0)) : 0;
          l.valorTexto = l.valor > 0 ? this.formatar(l.valor) : '';
          this.ajustarQuantidade(l);
        });
        this.emitir();
      },
      filtro: {
        deep: true,
        handler() {
          if (!this.aberto) return;
          clearTimeout(this.temporizador);
          if (!this.podeBuscar) {
            this.pedido++;
            this.carregando = false;
            this.lista = null;
            return;
          }
          this.temporizador = setTimeout(() => this.buscar(), 400);
        },
      },
    },
    beforeDestroy() {
      clearTimeout(this.temporizador);
    },
    methods: {
      formatar(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      formatarQuantidade(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 4 });
      },
      abrir() {
        this.lista = null;
        this.erro = '';
        this.detalhe = null;
        this.escolhida = null;
        this.filtro = { busca: this.sugestoesBusca[0] || '', dataIni: null, dataFim: null };
        this.aberto = true;
        if (this.podeBuscar) this.buscar();
        this.$nextTick(() => this.$refs.busca && this.$refs.busca.focus());
      },
      fechar() {
        clearTimeout(this.temporizador);
        this.aberto = false;
      },
      sugestaoAtiva(s) {
        return this.filtro.busca.trim().toUpperCase() === s.toUpperCase();
      },
      alternarSugestao(s) {
        this.filtro.busca = this.sugestaoAtiva(s) ? '' : s;
      },
      limparFiltros() {
        this.filtro = { busca: '', dataIni: null, dataFim: null };
      },
      buscarAgora() {
        clearTimeout(this.temporizador);
        if (this.podeBuscar) this.buscar();
      },
      enterNoFiltro(e) {
        if (!e.target || e.target.tagName !== 'INPUT') return;
        e.preventDefault();
        e.stopPropagation();
        this.buscarAgora();
      },
      buscar() {
        const pedido = ++this.pedido;
        const f = this.filtro;

        this.carregando = true;
        this.erro = '';

        conciliacaoProjetoServico.solicitacoesDevolucao({
          busca: f.busca.trim(),
          dataIni: f.dataIni ? moment(f.dataIni).format('YYYY-MM-DD') : '',
          dataFim: f.dataFim ? moment(f.dataFim).format('YYYY-MM-DD') : '',
          valor: this.total ? this.total.toFixed(2) : '',
        })
          .then(lista => {
            if (pedido !== this.pedido) return;
            this.carregando = false;
            this.lista = lista || [];
            if (this.escolhida && !this.lista.some(sp => sp.idSolicitacao === this.escolhida.idSolicitacao)) {
              this.pedidoDetalhe++;
              this.escolhida = null;
              this.detalhe = null;
              this.carregandoDetalhe = false;
            }
            if (this.lista.length && this.lista[0].numeroConfere && !this.escolhida) this.escolher(this.lista[0]);
          })
          .catch(res => {
            if (pedido !== this.pedido) return;
            this.carregando = false;
            this.erro = (res && res.body && res.body.message) || 'Não foi possível buscar as solicitações de pagamento.';
          });
      },
      escolher(sp) {
        this.escolhida = sp;
        const pedido = ++this.pedidoDetalhe;

        this.carregandoDetalhe = true;
        this.erroDetalhe = '';
        this.detalhe = null;

        conciliacaoProjetoServico.solicitacaoDevolucao(sp.idSolicitacao, this.idContaCript)
          .then(detalhe => {
            if (pedido !== this.pedidoDetalhe) return;
            this.carregandoDetalhe = false;
            this.detalhe = detalhe;
          })
          .catch(res => {
            if (pedido !== this.pedidoDetalhe) return;
            this.carregandoDetalhe = false;
            this.erroDetalhe = (res && res.body && res.body.message) || 'Não foi possível carregar a solicitação.';
          });
      },
      ehEscolhida(sp) {
        return !!(this.escolhida && this.escolhida.idSolicitacao === sp.idSolicitacao);
      },
      saldoDe(sp) {
        return arredondar((+sp.valor || 0) - (+sp.valorDevolvido || 0));
      },
      projetoDe(sp) {
        if (!sp.nomeProjeto) return '';
        return sp.qtdeRateios > 1 ? sp.nomeProjeto + ' (+' + (sp.qtdeRateios - 1) + ' linhas)' : sp.nomeProjeto;
      },
      itemDe(r) {
        return r.idProjetoItemControle > 0 ? (r.nomeItem || 'Item ' + r.idProjetoItemControle) : '';
      },
      semConta(linhas) {
        return (linhas || []).filter(l => l.contaNoProjeto === false);
      },
      textoSemConta(linhas, nomeConta) {
        const projetos = this.semConta(linhas).map(l => l.nomeProjeto).filter((n, i, a) => a.indexOf(n) === i);
        const conta = nomeConta || (this.value && this.value.nomeContaExtrato) || 'desta conta';
        return (projetos.length === 1 ? 'O projeto ' + projetos[0] + ' não tem' : 'Os projetos ' + projetos.join(', ') + ' não têm')
          + ' a conta ' + conta + ' cadastrada. Cadastre a conta no projeto antes de gravar.';
      },
      podeConfirmar() {
        return !!(this.detalhe && this.detalhe.rateios.some(r => (+r.saldo || 0) > 0));
      },
      totalmenteDevolvida(sp) {
        return (+sp.valorDevolvido || 0) > 0 && this.saldoDe(sp) < 0.005;
      },
      confirmar() {
        if (!this.podeConfirmar()) return;

        const linhas = this.detalhe.rateios.map(r => Object.assign({}, r, {
          valorPago: +r.valor || 0, quantidadeOriginal: +r.quantidade || 0,
          valor: 0, valorTexto: '', quantidade: 0, quantidadeTexto: '0', quantidadeManual: false,
        }));

        const comSaldo = linhas.filter(l => (+l.saldo || 0) > 0);
        if (comSaldo.length === 1) {
          const linha = comSaldo[0];
          linha.valor = arredondar(Math.min(this.total, linha.saldo));
          linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
          this.ajustarQuantidade(linha);
        }

        this.$emit('input', Object.assign({}, this.detalhe, { linhas }));
        this.fechar();
      },
      remover() {
        this.$emit('input', null);
      },
      digitarValor(linha, evento) {
        linha.valorTexto = evento.target.value;
        linha.valor = arredondar(lerNumero(linha.valorTexto));
        this.ajustarQuantidade(linha);
        this.emitir();
      },
      sairValor(linha) {
        linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
      },
      digitarQuantidade(linha, evento) {
        linha.quantidadeTexto = evento.target.value;
        linha.quantidade = Math.max(0, lerNumero(linha.quantidadeTexto));
        linha.quantidadeManual = true;
        this.emitir();
      },
      ajustarQuantidade(linha) {
        if (linha.quantidadeManual || !(linha.idProjetoItemControle > 0)) return;
        const devolveTudo = Math.abs(linha.valor - (+linha.valorPago || 0)) < 0.005;
        linha.quantidade = devolveTudo ? (+linha.quantidadeOriginal || 0) : 0;
        linha.quantidadeTexto = this.formatarQuantidade(linha.quantidade);
      },
      usarSaldo(linha) {
        const restante = arredondar(this.falta + (+linha.valor || 0));
        linha.valor = arredondar(Math.max(0, Math.min(+linha.saldo || 0, restante)));
        linha.valorTexto = linha.valor > 0 ? this.formatar(linha.valor) : '';
        this.ajustarQuantidade(linha);
        this.emitir();
      },
      emitir() {
        this.$emit('input', Object.assign({}, this.value, { linhas: this.linhas.slice() }));
      },
    },
  }
</script>

<template>
  <div class="dsv">
    <div v-if="!value" class="dsv-vazio">
      <button type="button" class="dsv-botao" @click="abrir">
        <i class="fa fa-undo"></i> É devolução de solicitação de pagamento
      </button>
      <small>Estorno de compra, pagamento a maior, imposto não retido... O valor volta para o projeto, rubrica e item de onde saiu.</small>
    </div>

    <div v-else class="dsv-card" :class="{ 'dsv-card-invalido': invalido }">
      <div class="dsv-cab-card">
        <div class="dsv-card-txt">
          <div class="dsv-l1">
            <b class="mono">SP {{ value.idSolicitacao }}</b>
            <span class="dsv-nome" :title="value.nomePessoa">{{ value.nomePessoa || '—' }}</span>
            <span class="dsv-valor mono">pago R$ {{ formatar(value.valor) }}</span>
          </div>
          <div class="dsv-l2">
            <span><i class="fa fa-calendar"></i> Pago em {{ value.dataPagamentoStr || '—' }}</span>
            <span v-if="value.valorDevolvido > 0" class="dsv-ja">Já devolvido R$ {{ formatar(value.valorDevolvido) }}</span>
            <span v-if="value.complemento" class="dsv-compl" :title="value.complemento">{{ value.complemento }}</span>
          </div>
        </div>
        <div class="dsv-card-acoes">
          <button type="button" class="dsv-mini" title="Trocar a solicitação" @click="abrir"><i class="fa fa-exchange"></i></button>
          <button type="button" class="dsv-mini dsv-mini-remover" title="Não é devolução" @click="remover"><i class="fa fa-times"></i></button>
        </div>
      </div>

      <table class="dsv-tab dsv-tab-linhas">
        <thead>
          <tr>
            <th>Projeto</th>
            <th>Rubrica / subrubrica</th>
            <th v-if="temItem">Item de controle</th>
            <th class="dsv-dir">Pago</th>
            <th class="dsv-dir">Saldo</th>
            <th class="dsv-dir dsv-col-valor">Valor devolvido</th>
            <th v-if="temItem" class="dsv-dir dsv-col-qtd">Qtd. devolvida</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(l, i) in linhas" :key="'l' + i" :class="{ 'dsv-sem-saldo': !(l.saldo > 0) }">
            <td class="dsv-cel-txt" :title="l.nomeProjeto">
              <i v-if="l.contaNoProjeto === false" class="fa fa-exclamation-triangle dsv-sem-conta" title="A conta do extrato não está cadastrada neste projeto"></i>
              {{ l.nomeProjeto }}
            </td>
            <td class="dsv-cel-txt" :title="l.nomeRubrica + ' / ' + l.nomeSubrubrica">
              {{ l.nomeRubrica }}<small class="dsv-sub">{{ l.nomeSubrubrica }}</small>
            </td>
            <td v-if="temItem" class="dsv-cel-txt" :title="itemDe(l)">
              {{ itemDe(l) || '—' }}
              <small v-if="l.idProjetoItemControle > 0" class="dsv-sub">qtd. paga {{ formatarQuantidade(l.quantidadeOriginal) }}</small>
            </td>
            <td class="mono dsv-dir">{{ formatar(l.valorPago) }}</td>
            <td class="mono dsv-dir">
              {{ formatar(l.saldo) }}
              <small v-if="l.valorDevolvido > 0" class="dsv-sub">devolvido {{ formatar(l.valorDevolvido) }}</small>
            </td>
            <td class="dsv-dir">
              <div class="dsv-valor-campo" :class="{ 'dsv-erro-campo': l.valor > l.saldo + 0.005 }">
                <input :id="'dsv-valor-' + i" type="text" class="form-control mono" :value="l.valorTexto" maxlength="20" placeholder="0,00"
                       :disabled="!(l.saldo > 0)" @input="digitarValor(l, $event)" @blur="sairValor(l)">
                <button v-if="l.saldo > 0 && Math.abs(falta) >= 0.005" type="button" class="dsv-usar" title="Usar o que falta, até o saldo da linha"
                        @click="usarSaldo(l)"><i class="fa fa-level-down"></i></button>
              </div>
            </td>
            <td v-if="temItem" class="dsv-dir">
              <input v-if="l.idProjetoItemControle > 0" :id="'dsv-qtd-' + i" type="text" class="form-control mono dsv-qtd"
                     :value="l.quantidadeTexto" maxlength="12" :disabled="!(l.valor > 0)" @input="digitarQuantidade(l, $event)">
            </td>
          </tr>
        </tbody>
      </table>

      <div class="dsv-rodape-card">
        <div v-if="semConta(linhas).length" class="dsv-aviso-conta">
          <i class="fa fa-exclamation-triangle"></i> {{ textoSemConta(linhas) }}
        </div>
        <span v-if="linhasAcimaDoSaldo.length" class="dsv-cont dsv-falta">
          <i class="fa fa-ban"></i> Valor acima do saldo da linha — a devolução não pode passar do que ainda não foi devolvido.
        </span>
        <span v-else-if="Math.abs(falta) < 0.005" class="dsv-cont dsv-bate">R$ {{ formatar(distribuido) }} · bate com o crédito</span>
        <span v-else-if="falta > 0" class="dsv-cont dsv-ok">R$ {{ formatar(distribuido) }} distribuídos · faltam R$ {{ formatar(falta) }}</span>
        <span v-else class="dsv-cont dsv-falta">R$ {{ formatar(distribuido) }} distribuídos · passou R$ {{ formatar(-falta) }}</span>
        <small v-if="temItem" class="dsv-dica">A quantidade só volta ao item quando a devolução é do total da linha. Parcial nasce com 0 — ajuste se devolveram unidades.</small>
      </div>
    </div>

    <div v-if="aberto" class="dsv-back">
      <div class="dsv-modal">
        <div class="dsv-cab">
          <h4><i class="fa fa-undo"></i> Devolução de solicitação de pagamento</h4>
          <small>Escolha a SP que gerou o pagamento devolvido. Aparecem só as SPs com lançamento pago.</small>
        </div>

        <div class="dsv-filtros" @keydown.enter="enterNoFiltro">
          <div class="dsv-filtro dsv-filtro-lg">
            <label>Número da SP, favorecido ou CPF/CNPJ</label>
            <div class="dsv-busca-linha">
              <input ref="busca" type="text" class="form-control" v-model="filtro.busca" maxlength="100" placeholder="Ex.: 245670 ou nome do favorecido">
              <button type="button" class="btn btn-success no-margins" :disabled="carregando" @click="buscarAgora" title="Buscar agora (Enter)">
                <i class="fa" :class="carregando ? 'fa-spinner fa-pulse' : 'fa-search'"></i> Buscar
              </button>
            </div>
          </div>
          <div class="dsv-filtro dsv-filtro-sm">
            <label>Pago de</label>
            <date-picker v-model="filtro.dataIni" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="Selecione"
                         :editable="false" :shortcuts="false" :append-to-body="true"
                         :popup-style="{ zIndex: 3600 }" style="width:100%"></date-picker>
          </div>
          <div class="dsv-filtro dsv-filtro-sm">
            <label>até</label>
            <date-picker v-model="filtro.dataFim" format="DD/MM/YYYY" lang="pt-br" input-class="form-control" placeholder="Selecione"
                         :editable="false" :shortcuts="false" :append-to-body="true"
                         :popup-style="{ zIndex: 3600 }" style="width:100%"></date-picker>
          </div>
          <div class="dsv-chips">
            <button v-for="s in sugestoesBusca" :key="'sug-' + s" type="button" class="dsv-chip" :class="{ ativo: sugestaoAtiva(s) }" @click="alternarSugestao(s)">
              <i v-if="sugestaoAtiva(s)" class="fa fa-check"></i> Do extrato: SP {{ s }}
            </button>
            <button v-if="filtro.busca || filtro.dataIni || filtro.dataFim" type="button" class="dsv-chip dsv-chip-limpar" @click="limparFiltros">
              <i class="fa fa-eraser"></i> Limpar filtros
            </button>
            <small class="dsv-dica-filtro">Sem datas, a busca olha os pagamentos dos últimos 12 meses; as de valor maior ou igual ao crédito vêm primeiro.</small>
          </div>
        </div>

        <div class="dsv-corpo">
          <div class="dsv-lista">
            <div v-if="!podeBuscar && !carregando" class="dsv-info"><i class="fa fa-search"></i> Digite o número da SP, o favorecido (3 letras ou mais) ou o CPF/CNPJ, ou escolha as datas do pagamento.</div>
            <div v-else-if="carregando && !lista" class="dsv-info"><i class="fa fa-spinner fa-pulse"></i> Buscando as solicitações...</div>
            <div v-else-if="erro" class="dsv-info dsv-erro">{{ erro }}</div>
            <div v-else-if="lista && !lista.length" class="dsv-info">Nenhuma solicitação paga com esses filtros.</div>
            <template v-else-if="lista">
              <div v-if="noLimite" class="dsv-limite"><i class="fa fa-info-circle"></i> Mostrando {{ lista.length }}. Digite o número da SP para ir direto.</div>
              <table class="dsv-tab" :class="{ 'dsv-tab-carregando': carregando }">
                <thead>
                  <tr>
                    <th></th>
                    <th>SP</th>
                    <th>Pago em</th>
                    <th>Favorecido / Projeto</th>
                    <th>Complemento</th>
                    <th class="dsv-dir">Pago</th>
                    <th class="dsv-dir">Devolvido</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sp in lista" :key="sp.idSolicitacao" :class="{ on: ehEscolhida(sp), 'dsv-devolvida': totalmenteDevolvida(sp) }" @click="escolher(sp)">
                    <td><input type="radio" :checked="ehEscolhida(sp)" @click.stop="escolher(sp)"></td>
                    <td class="mono dsv-nowrap">{{ sp.idSolicitacao }}</td>
                    <td class="mono dsv-nowrap">{{ sp.dataPagamentoStr }}</td>
                    <td class="dsv-cel-nome">
                      <div :title="sp.nomePessoa">{{ sp.nomePessoa || '—' }}</div>
                      <small v-if="sp.nomeProjeto" :title="sp.nomeProjeto">{{ projetoDe(sp) }}</small>
                    </td>
                    <td class="dsv-cel-compl"><div :title="sp.complemento">{{ sp.complemento || '—' }}</div></td>
                    <td class="mono dsv-dir">{{ formatar(sp.valor) }}</td>
                    <td class="mono dsv-dir">
                      {{ sp.valorDevolvido > 0 ? formatar(sp.valorDevolvido) : '—' }}
                      <small v-if="totalmenteDevolvida(sp)" class="dsv-sub dsv-tag-total">tudo devolvido</small>
                      <small v-else-if="sp.valorDevolvido > 0" class="dsv-sub">saldo {{ formatar(saldoDe(sp)) }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>

          <div class="dsv-detalhe">
            <div v-if="!escolhida" class="dsv-info">Clique numa solicitação para ver o rateio.</div>
            <div v-else-if="carregandoDetalhe" class="dsv-info"><i class="fa fa-spinner fa-pulse"></i> Carregando a solicitação...</div>
            <div v-else-if="erroDetalhe" class="dsv-info dsv-erro">{{ erroDetalhe }}</div>
            <template v-else-if="detalhe">
              <div class="dsv-det-cab">
                <b class="mono">SP {{ detalhe.idSolicitacao }}</b>
                <span class="mono">R$ {{ formatar(detalhe.valor) }}</span>
              </div>
              <dl class="dsv-dl">
                <dt>Favorecido</dt>
                <dd>{{ detalhe.nomePessoa || '—' }}<small v-if="detalhe.cpfcnpj" class="mono"> · {{ detalhe.cpfcnpj }}</small></dd>
                <dt>Pago em</dt>
                <dd class="mono">{{ detalhe.dataPagamentoStr || '—' }} · lançamento {{ detalhe.idLancamento }}</dd>
                <template v-if="detalhe.complemento"><dt>Complemento</dt><dd>{{ detalhe.complemento }}</dd></template>
              </dl>
              <div class="dsv-secao">
                <h5>Devoluções já feitas</h5>
                <div v-if="!detalhe.devolucoes || !detalhe.devolucoes.length" class="dsv-nenhuma">Nenhuma devolução vinculada a esta SP.</div>
                <template v-else>
                  <div v-for="d in detalhe.devolucoes" :key="'d' + d.idLancamento" class="dsv-rat">
                    <div class="dsv-linha">
                      <span class="mono">{{ d.dataStr || d.dataCadastroStr }} · lanç. {{ d.idLancamento }}</span>
                      <span class="mono">{{ formatar(d.valor) }}</span>
                    </div>
                    <div class="dsv-rat-l2">
                      <span class="dsv-linha-txt" :title="d.nomeConta + (d.documento ? ' · ' + d.documento : '')">
                        {{ d.nomeConta }}<template v-if="d.documento"> · {{ d.documento }}</template>
                      </span>
                    </div>
                  </div>
                  <div class="dsv-saldo-sp" :class="{ 'dsv-saldo-zero': saldoDe(detalhe) < 0.005 }">
                    <span>Pago {{ formatar(detalhe.valor) }} − devolvido {{ formatar(detalhe.valorDevolvido) }}</span>
                    <b class="mono">saldo {{ formatar(saldoDe(detalhe)) }}</b>
                  </div>
                  <div v-if="saldoDe(detalhe) < 0.005" class="dsv-aviso-conta">
                    <i class="fa fa-ban"></i> Esta SP já foi devolvida por inteiro. Não dá para vincular outra devolução.
                  </div>
                  <div v-else-if="total > saldoDe(detalhe) + 0.005" class="dsv-aviso-saldo">
                    <i class="fa fa-exclamation-triangle"></i> O crédito (R$ {{ formatar(total) }}) passa do saldo da SP. Só R$ {{ formatar(saldoDe(detalhe)) }} podem ir para ela; o resto precisa de outro lançamento.
                  </div>
                </template>
              </div>
              <div class="dsv-secao">
                <h5>Rateio do pagamento</h5>
                <div v-if="semConta(detalhe.rateios).length" class="dsv-aviso-conta">
                  <i class="fa fa-exclamation-triangle"></i>
                  {{ textoSemConta(detalhe.rateios, detalhe.nomeContaExtrato) }}
                </div>
                <div v-for="(r, i) in detalhe.rateios" :key="'r' + i" class="dsv-rat">
                  <div class="dsv-linha">
                    <span class="dsv-linha-txt" :title="r.nomeProjeto">{{ r.nomeProjeto }}</span>
                    <span class="mono">{{ formatar(r.valor) }}</span>
                  </div>
                  <div class="dsv-rat-l2">
                    <span class="dsv-linha-txt" :title="r.nomeSubrubrica">{{ r.nomeSubrubrica }}</span>
                    <span v-if="r.valorDevolvido > 0" class="mono dsv-ja">devolvido {{ formatar(r.valorDevolvido) }}</span>
                  </div>
                  <div v-if="r.idProjetoItemControle > 0" class="dsv-rat-l2">
                    <span class="dsv-linha-txt" :title="itemDe(r)"><i class="fa fa-cube"></i> {{ itemDe(r) }}</span>
                    <span class="mono">qtd. {{ formatarQuantidade(r.quantidade) }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="dsv-rodape">
          <span v-if="escolhida" class="dsv-cont dsv-ok">SP {{ escolhida.idSolicitacao }} · R$ {{ formatar(escolhida.valor) }}</span>
          <span v-else class="dsv-cont">Nenhuma solicitação escolhida</span>
          <button type="button" class="btn btn-primary" :disabled="!podeConfirmar() || carregandoDetalhe" @click="confirmar">
            <i class="fa fa-link"></i> Usar esta solicitação
          </button>
          <button type="button" class="dsv-sair" @click="fechar"><i class="fa fa-sign-out"></i> Sair</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
  .dsv { margin: 0; }
  .dsv-vazio { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 10px; }
  .dsv-vazio small { color: #8a939c; font-size: 11.5px; }
  .dsv-botao { height: 28px; padding: 0 11px; background: #fff; border: 1px solid #2b6cb0; border-radius: 5px; font-size: 12px; font-weight: 600; color: #2b6cb0; }
  .dsv-botao:hover { background: #eef4fb; }
  .dsv-card { border: 1px solid #d6e3f2; background: #f5f9fd; border-radius: 6px; padding: 8px 10px; }
  .dsv-card-invalido { border-color: #e5b5b5; }
  .dsv-cab-card { display: flex; gap: 10px; align-items: flex-start; }
  .dsv-card-txt { flex: 1 1 auto; min-width: 0; }
  .dsv-l1 { display: flex; gap: 10px; align-items: baseline; font-size: 13px; color: #1c2024; min-width: 0; }
  .dsv-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-valor { flex: none; font-weight: 600; }
  .dsv-l2 { display: flex; flex-wrap: wrap; gap: 4px 14px; font-size: 11.5px; color: #6b747e; margin-top: 2px; min-width: 0; }
  .dsv-l2 .fa { color: #9aa3ac; }
  .dsv-compl { max-width: 360px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-ja { color: #8a5a00; }
  .dsv-aviso-conta { flex-basis: 100%; margin: 0 0 8px; padding: 7px 10px; border-radius: 5px; background: #fdecea; color: #a5281b; font-size: 12px; font-weight: 600; line-height: 1.4; }
  .dsv-sem-conta { color: #c0392b; margin-right: 3px; }
  .dsv-card-acoes { flex: none; display: flex; gap: 4px; }
  .dsv-mini { width: 26px; height: 26px; border: 1px solid #d3d8de; border-radius: 4px; background: #fff; color: #5b6570; }
  .dsv-mini:hover { background: #eef4fb; border-color: #2b6cb0; color: #2b6cb0; }
  .dsv-mini-remover:hover { background: #fbeaea; border-color: #e5b5b5; color: #a13c3c; }
  .dsv-tab-linhas { margin-top: 8px; background: #fff; border: 1px solid #e6eaee; border-radius: 5px; }
  .dsv-tab-linhas td { vertical-align: middle; }
  .dsv-cel-txt { max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-col-valor { width: 150px; }
  .dsv-col-qtd { width: 100px; }
  .dsv-valor-campo { display: flex; gap: 4px; justify-content: flex-end; }
  .dsv-valor-campo .form-control { height: 28px; font-size: 12.5px; text-align: right; width: 110px; }
  .dsv-erro-campo .form-control { border-color: #d9534f; background: #fdf3f3; }
  .dsv-qtd { height: 28px; font-size: 12.5px; text-align: right; width: 80px; display: inline-block; }
  .dsv-usar { flex: none; width: 28px; height: 28px; border: 1px solid #d3d8de; border-radius: 4px; background: #fff; color: #2b6cb0; }
  .dsv-usar:hover { background: #eef4fb; border-color: #2b6cb0; }
  .dsv-sem-saldo { opacity: .55; }
  .dsv-devolvida td { color: #9aa3ac; }
  .dsv-tag-total { color: #a13c3c; font-weight: 600; }
  .dsv-nenhuma { font-size: 12px; color: #8a939c; }
  .dsv-saldo-sp { display: flex; justify-content: space-between; gap: 10px; font-size: 12px; color: #4b545e; padding: 6px 8px; border-radius: 5px; background: #eef4fb; margin-bottom: 6px; }
  .dsv-saldo-zero { background: #fbeeee; color: #a13c3c; }
  .dsv-aviso-saldo { margin: 0 0 8px; padding: 7px 10px; border-radius: 5px; background: #fffaf0; border: 1px solid #f0dfb8; color: #8a5a00; font-size: 12px; font-weight: 600; line-height: 1.4; }
  .dsv-rodape-card { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; margin-top: 8px; }
  .dsv-dica { color: #8a939c; font-size: 11.5px; }

  .dsv-back { position: fixed; inset: 0; background: rgba(16,24,40,.5); z-index: 3400; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .dsv-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); width: 100%; max-width: 1180px; max-height: 92vh; display: flex; flex-direction: column; }
  .dsv-cab { padding: 16px 20px 12px; border-bottom: 1px solid #e6eaee; flex: 0 0 auto; }
  .dsv-cab h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #1c2024; }
  .dsv-cab small { color: #8a939c; font-size: 12.5px; }
  .dsv-filtros { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px; padding: 12px 20px; border-bottom: 1px solid #eef1f4; background: #fafbfc; flex: 0 0 auto; }
  .dsv-filtro { display: flex; flex-direction: column; flex: 1 1 130px; min-width: 0; }
  .dsv-filtro-lg { flex: 3 1 260px; }
  .dsv-filtro-sm { flex: 0 1 140px; }
  .dsv-filtro label { font-size: 11.5px; font-weight: 600; color: #4b545e; margin-bottom: 3px; }
  .dsv-filtro .form-control { height: 32px; font-size: 12.5px; }
  .dsv-busca-linha { display: flex; gap: 6px; }
  .dsv-busca-linha .form-control { flex: 1 1 auto; min-width: 0; }
  .dsv-busca-linha .btn { height: 32px; padding: 0 12px; font-size: 12.5px; flex: 0 0 auto; }
  .dsv-chips { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; flex: 1 1 100%; }
  .dsv-chip { height: 28px; padding: 0 10px; border: 1px dashed #b9c3cd; border-radius: 14px; background: #fff; color: #2b6cb0; font-size: 12px; font-weight: 600; }
  .dsv-chip:hover { background: #f1f5f9; border-color: #2b6cb0; }
  .dsv-chip.ativo { border-style: solid; border-color: #0f8a5f; background: #e8f5ef; color: #0a6d4d; }
  .dsv-chip-limpar { color: #5b6570; }
  .dsv-dica-filtro { color: #8a939c; font-size: 11.5px; }
  .dsv-corpo { display: flex; flex: 1 1 auto; min-height: 280px; overflow: hidden; }
  .dsv-lista { flex: 1 1 auto; min-width: 0; overflow: auto; padding: 12px 16px 12px 20px; }
  .dsv-detalhe { flex: 0 0 330px; overflow: auto; padding: 12px 20px 12px 16px; border-left: 1px solid #eef1f4; background: #fbfcfd; }
  .dsv-info { padding: 28px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .dsv-erro { color: #a13c3c; }
  .dsv-limite { font-size: 12px; color: #8a5a00; background: #fffaf0; border: 1px solid #f0dfb8; border-radius: 5px; padding: 7px 10px; margin-bottom: 10px; }
  .dsv-tab { width: 100%; border-collapse: collapse; font-size: 12.5px; color: #3b444d; }
  .dsv-tab-carregando { opacity: .55; }
  .dsv-tab th { position: sticky; top: 0; background: #fff; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; text-align: left; padding: 6px 8px; border-bottom: 1px solid #e6e9ed; }
  .dsv-tab td { padding: 7px 8px; border-bottom: 1px solid #f0f2f4; vertical-align: top; }
  .dsv-lista .dsv-tab tbody tr { cursor: pointer; }
  .dsv-lista .dsv-tab tbody tr:hover { background: #f7f9fa; }
  .dsv-tab tbody tr.on { background: #eef4fb; }
  .dsv-tab input[type=radio] { margin: 0; }
  .dsv-nowrap { white-space: nowrap; }
  .dsv-sub { display: block; color: #8a939c; font-size: 11px; }
  .dsv-cel-nome { max-width: 260px; }
  .dsv-cel-nome div, .dsv-cel-compl div { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #1c2024; }
  .dsv-cel-nome small { display: block; color: #8a939c; font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-cel-compl { max-width: 220px; }
  .dsv-cel-compl div { color: #5b6570; }
  .dsv-dir { text-align: right; white-space: nowrap; }
  .dsv-det-cab { display: flex; justify-content: space-between; gap: 10px; font-size: 15px; color: #1c2024; margin-bottom: 10px; }
  .dsv-dl { margin: 0; font-size: 12.5px; }
  .dsv-dl dt { font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; margin-top: 8px; }
  .dsv-dl dd { margin: 1px 0 0; color: #1c2024; word-break: break-word; }
  .dsv-dl dd small { color: #6b747e; }
  .dsv-secao { margin-top: 14px; }
  .dsv-secao h5 { margin: 0 0 6px; font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; }
  .dsv-rat { border: 1px solid #e6eaee; background: #fff; border-radius: 5px; padding: 6px 8px; margin-bottom: 6px; }
  .dsv-linha { display: flex; justify-content: space-between; gap: 10px; font-size: 12.5px; color: #1c2024; }
  .dsv-rat-l2 { display: flex; justify-content: space-between; gap: 10px; font-size: 11.5px; color: #6b747e; margin-top: 2px; min-width: 0; }
  .dsv-linha-txt { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .dsv-rodape { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 12px 20px; border-top: 1px solid #e6eaee; flex: 0 0 auto; }
  .dsv-cont { margin-right: auto; font-size: 12px; font-weight: 600; color: #6b747e; padding: 5px 9px; border-radius: 5px; }
  .dsv-rodape-card .dsv-cont { margin-right: 0; }
  .dsv-ok { background: #eef4fb; color: #2b6cb0; }
  .dsv-bate { background: #e8f5ef; color: #0a6d4d; }
  .dsv-falta { background: #fbeeee; color: #a13c3c; }
  .dsv-sair { display: inline-flex; align-items: center; gap: 7px; background: #fdf1f1; border: 1px solid #e4d7d7; border-radius: 5px; padding: 6px 18px; font-size: 12.5px; font-weight: 600; color: #a13c3c; }
  .dsv-sair:hover { background: #fbe6e6; }

  @media (max-width: 860px) {
    .dsv-corpo { flex-direction: column; overflow: auto; }
    .dsv-lista { overflow: visible; }
    .dsv-detalhe { flex: none; border-left: none; border-top: 1px solid #eef1f4; }
    .dsv-tab-linhas { display: block; overflow-x: auto; }
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/DevolucaoSolicitacaoVinculo.vue